import { Col, Container, Row, Stack } from "react-bootstrap"

const HireFullStackDeveloperContent = () => {  
    return (
                
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Full Stack Developers for End-to-End Web & App Solutions
                        </h2>
                        <p>
                            Need developers who can handle both frontend and backend with equal expertise? Our seasoned full stack developers bring complete solutions to the table — from stunning UI to robust backend architecture — ensuring your digital product is delivered faster and smarter.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire Full Stack Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>
                                    Frontend + Backend Mastery
                                </b>
                                <p>
                                    Our developers are skilled in technologies like HTML5, CSS3, JavaScript, React, Angular, Node.js, PHP, Laravel, MongoDB, MySQL, and more.
                                </p>
                            </li>
                            <li>
                                <b>
                                    End-to-End Project Ownership
                                </b>
                                <p>
                                    From database design to responsive UI, our full stack developers manage the entire development lifecycle efficiently.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Agile & Scalable Solutions
                                </b>
                                <p>
                                    We build flexible, scalable applications optimized for performance, user engagement, and business growth.
                                </p>
                            </li>
                            <li>
                                <b>
                                    API Development & Integration
                                </b>
                                <p>
                                    We create secure and efficient RESTful APIs and seamlessly integrate third-party services for a connected experience.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Flexible Hiring Options
                                </b>
                                <p>
                                    Choose hourly, part-time, or full-time models — depending on your timeline, project size, and budget.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our Full Stack Development Services
                        </h2>
                        <ul>
                            <li>Full Stack Web & App Development</li>
                            <li>Custom Business Applications</li>
                            <li>Frontend Development (React, Angular, Vue)</li>
                            <li>Backend Development (Node.js, PHP, Laravel)</li>
                            <li>API & Database Integration</li>
                            <li>Performance Optimization & Maintenance</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Let’s Build Something Powerful
                        </h2>
                        <p>
                            Our full stack developers combine technical depth with real-world problem solving to deliver high-impact digital solutions. Get in touch today for a free consultation and project quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireFullStackDeveloperContent;